
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

function ResetPasswordHandler() {
    const {id, token} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Verify token first before showing modal
        fetch('http://localhost:3001/verify-reset-token', {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json',
            },
            body: JSON.stringify({id, token})
        })
        .then(response => response.json())
        .then(data => {
            if(data.valid) {
                localStorage.setItem('resetToken', token);
                localStorage.setItem('resetUserId', id);
                window.dispatchEvent(new CustomEvent("showResetPassword", {
                    detail: {token, userId: id}
                }));
                navigate('/');
            } else {
                alert("Invalid or expired reset link");
                navigate('/');
            }
        })
        .catch(err => {
            console.error(err);
            alert("Error verifying reset link");
            navigate('/');
        });
    },[id, token, navigate])
  return null;
}

export default ResetPasswordHandler